<template>
  <div class="setupAccount">
    <el-dialog
      title="转化配置"
      width="800px"
      :visible="visible"
      @close="toggleVisible(false)"
      append-to-body
    >
      <el-form
        :model="formData"
        label-width="160px"
        label-suffix="："
      >
        <el-form-item label="链接来源">
          <el-radio-group v-model="formData.utmSourceConfig">
            <el-radio label="GMALL3">商城3.0</el-radio>
            <el-radio label="SHOP_PLUS">商城Plus</el-radio>
            <el-radio label="SHOPLINE">shopline</el-radio>
            <el-radio label="SHOPIFY">shopify</el-radio>
            <el-radio label="SOHPBASE">shopbase</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="加购回传去重">
          <el-radio-group v-model="formData.distinctCheckout">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="点击型转化时间范围">
          <div class="conversion-window-wrapper">
            <div class="conversion-window-select">
              <el-select
                v-model="formData.conversionWindow"
                placeholder="请选择"
                style="width: 140px"
                @change="handleConversionWindowChange"
              >
                <el-option
                  v-for="item in conversionWindowOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input-number
                v-if="formData.conversionWindow === 'custom'"
                v-model="formData.customConversionDays"
                :min="1"
                :max="90"
                :precision="0"
                style="width: 120px; margin-left: 10px"
                placeholder="1-90"
              ></el-input-number>
              <span
                v-if="formData.conversionWindow === 'custom'"
                style="margin-left: 4px"
                >天</span
              >
            </div>
            <div class="conversion-window-desc">
              <span class="text-[12px] text-gray-400"
                >用户与您的广告互动后，可能过了几天才完成转化。请选择用户与广告互动后，要在多长时间内统计转化。</span
              >
              <el-popover
                placement="top"
                width="360"
                trigger="hover"
                popper-class="conversion-window-popover"
              >
                <div class="popover-content">
                  <p>转化时间范围是指用户与广告互动后，系统可以在多长时间内统计转化。</p>
                  <p style="margin-top: 12px">
                    示例：假设您将转化时间范围设为 30 天。如果某个用户点击了您的广告，然后在 29
                    天后出手购买您的商品，系统就会将此计为一次转化。如果用户在点击广告后过了 31
                    天才出手购买，则不会计为转化。
                  </p>
                  <a
                    href="https://support.google.com/google-ads/answer/3123169?ctx=tltp&_gl=1*fhngc0*_ga*OTcyNDU0NjE1LjE3NzIwMTM0MTg.*_ga_V9K47ZG8NP*czE3NzM4MTg2NzIkbzIkZzAkdDE3NzM4MTg2NzIkajYwJGwwJGgw"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="popover-link"
                    >了解详情</a
                  >
                </div>
                <i
                  slot="reference"
                  class="el-icon-question"
                  style="margin-left: 4px; cursor: pointer; color: #909399"
                ></i>
              </el-popover>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="主要目标">
          <el-radio-group v-model="formData.setData">
            <el-radio label="purchase_primary">购买</el-radio>
            <el-radio label="checkout_primary">开始结账</el-radio>
            <el-radio :label="false">无</el-radio>
          </el-radio-group>
          <div class="tips">
            <span v-show="!formData.setData">需要在账户中配置API转化之外的其他跟踪事件</span>
          </div>
        </el-form-item> -->
      </el-form>
      <div
        solt="footer"
        class="dp-flex justify-end"
      >
        <el-button
          @click="toggleVisible(false)"
          :loading="loading"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="sure"
          :loading="loading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { setupAccount } from '@/api/google/account';
import { mapState } from 'vuex';
export default {
  props: {
    visible: Boolean,
    account_ids: Array,
    isOne: Boolean,
    settinginfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      formData: {
        // setData: 'purchase_primary',
        utmSourceConfig: 'GMALL3',
        distinctCheckout: false,
        conversionWindow: '30', // 转化时间范围，默认30天
        customConversionDays: 30, // 自定义天数
        // purchase_primary: true, // 加购配置
        // checkout_primary: false, // 结账设置
      },
      conversionWindowOptions: [
        { label: '自定义', value: 'custom' },
        { label: '90 天', value: '90' },
        { label: '60 天', value: '60' },
        { label: '45 天', value: '45' },
        { label: '30 天', value: '30' },
        { label: '4 周', value: '4week' },
        { label: '3 周', value: '3week' },
        { label: '2 周', value: '2week' },
        { label: '1 周', value: '1week' },
      ],
    };
  },
  computed: {
    ...mapState('google', ['createAdAccount']),
  },
  methods: {
    toggleVisible(bool) {
      if (this.loading) return;
      this.$emit('toggleVisible', bool);
    },
    handleConversionWindowChange(val) {
      // 选择非自定义时，重置自定义天数
      if (val !== 'custom') {
        this.formData.customConversionDays = 30;
      }
    },
    // 获取转化时间范围的天数
    getConversionDays() {
      const { conversionWindow, customConversionDays } = this.formData;
      if (conversionWindow === 'custom') {
        return customConversionDays;
      }
      // 周转换为天
      const weekMap = {
        '1week': 7,
        '2week': 14,
        '3week': 21,
        '4week': 28,
      };
      if (weekMap[conversionWindow]) {
        return weekMap[conversionWindow];
      }
      // 直接返回天数
      return parseInt(conversionWindow, 10);
    },
    sure() {
      let params = {
        distinctCheckout: this.formData.distinctCheckout,
        // purchase_primary: false,
        // checkout_primary: false,
      };
      //   if (this.formData.setData) {
      //     params[this.formData.setData] = true;
      //   }
      if (this.isOne) {
        params.accountId = this.account_ids.join('');
      } else {
        params.account_ids = this.account_ids;
      }
      params.utmSourceConfig = this.formData.utmSourceConfig;
      // 转化时间范围（天数）
      params.windowDays = this.getConversionDays();
      if (!params.utmSourceConfig) {
        this.$message({
          type: 'warning',
          message: '请选择链接类型',
        });
        return;
      }
      this.loading = true;
      setupAccount(params)
        .finally(() => {
          this.loading = false;
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(this.isOne ? '设置成功' : '一键配置后台执行中，执行完成后将通过钉钉消息提醒');
            console.log(this.createAdAccount.id, res.data.id);
            if (res.data.accountId == this.createAdAccount.id) {
              this.$store.commit('google/setCreateAdAccount', {
                ...this.createAdAccount,
                utmSourceConfig: this.formData.utmSourceConfig,
                distinctCheckout: this.formData.distinctCheckout,
                windowDays: params.windowDays,
              });
            }
            console.log(this.formData.customConversionDays, this.createAdAccount);

            setTimeout(() => {
              this.$emit('success', this.account_ids);
              this.toggleVisible(false);
            }, 1000);
          }
        });
    },
  },
  watch: {
    visible() {
      console.log(this.settinginfo);
      // 根据settinginfo中的天数反推conversionWindow
      let conversionWindow = '30';
      let customConversionDays = 30;
      if (this.settinginfo.windowDays) {
        const days = this.settinginfo.windowDays;
        // 检查是否匹配预设选项
        const presetDays = ['90', '60', '45', '30'];
        const weekDays = { 28: '4week', 21: '3week', 14: '2week', 7: '1week' };
        if (presetDays.includes(String(days))) {
          conversionWindow = String(days);
        } else if (weekDays[days]) {
          conversionWindow = weekDays[days];
        } else {
          conversionWindow = 'custom';
          customConversionDays = days;
        }
      }
      this.formData = {
        // setData: 'purchase_primary',
        utmSourceConfig: this.settinginfo.utmSourceConfig,
        distinctCheckout: this.settinginfo.distinctCheckout,
        conversionWindow,
        customConversionDays,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.setupAccount {
  ::v-deep .el-dialog {
    border-radius: 10px;
  }
  .tips {
    font-size: 12px;
    color: #999;
    height: 20px;
    line-height: 20px;
  }
  .conversion-window-wrapper {
    .conversion-window-select {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .conversion-window-desc {
      font-size: 12px;
      color: #909399;
      line-height: 1.6;
      display: flex;
      align-items: flex-start;
      span {
        flex: 1;
      }
    }
  }
}
</style>

<style lang="scss">
.conversion-window-popover {
  background: #303133 !important;
  border: none !important;
  .popper__arrow {
    border-top-color: #303133 !important;
    &::after {
      border-top-color: #303133 !important;
    }
  }
  .popover-content {
    color: #fff;
    font-size: 13px;
    line-height: 1.6;
    p {
      margin: 0;
    }
    .popover-link {
      display: inline-block;
      margin-top: 12px;
      color: #409eff;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
